import { Center, Loader } from '@mantine/core';

const Spinner = () => {
  return (
    <Center>
      <Loader type="oval" />
    </Center>
  );
};

export default Spinner;
